export const useIsAppInCypress = (): boolean => {
  return !!window?.Cypress || window.location.host.includes('.orbits.run');
};
